export default function pdpCollections(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_PDP_COLLECTION': {
      return {
        ...state,
        [action.payload.permalink.toLowerCase()]: action.payload,
      }
    }

    default:
      return state
  }
}
